import { render, staticRenderFns } from "./ChartBarNumbersBySegment.vue?vue&type=template&id=5078fdba&scoped=true"
import script from "./ChartBarNumbersBySegment.vue?vue&type=script&lang=js"
export * from "./ChartBarNumbersBySegment.vue?vue&type=script&lang=js"
import style0 from "./ChartBarNumbersBySegment.vue?vue&type=style&index=0&id=5078fdba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5078fdba",
  null
  
)

export default component.exports